import { useTranslation } from 'react-i18next'
import { ScrollText } from 'lucide-react'
import DeviceLogViewer from '../../components/DeviceLogs/DeviceLogViewer'
import { useManagedDevices } from '../../hooks/useManagedDevices'
import { getTenantId } from '../../config/tenant'

export default function DeviceLogsPage() {
  const { t } = useTranslation()
  const tenantId = getTenantId()
  const { data: devices } = useManagedDevices()

  const sortedDevices = (devices || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))

  return (
    <div className="p-4 md:p-6 space-y-4 max-w-7xl mx-auto">
      <div className="flex items-center gap-3">
        <ScrollText className="w-6 h-6 text-theme-secondary" />
        <div>
          <h1 className="text-xl font-semibold text-gray-900">{t('deviceLogs.title', 'Logs dos dispositivos')}</h1>
          <p className="text-sm text-gray-500">
            {t('deviceLogs.subtitle', 'Logs recebidos dos dispositivos gerenciados pela VPN (syslog), mais recentes primeiro.')}
          </p>
        </div>
      </div>
      <DeviceLogViewer tenantId={tenantId} devices={sortedDevices} />
    </div>
  )
}
